module.exports = "<router-outlet></router-outlet>\n"


//////////////////
// WEBPACK FOOTER
// /Users/mowebdevice/Desktop/Web Project/angular-scrubup/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main